var map = {
	"./add-round.svg": "./docs/_includes/icons/add-round.svg",
	"./add.svg": "./docs/_includes/icons/add.svg",
	"./addition-round.svg": "./docs/_includes/icons/addition-round.svg",
	"./addition.svg": "./docs/_includes/icons/addition.svg",
	"./alert-round.svg": "./docs/_includes/icons/alert-round.svg",
	"./alert.svg": "./docs/_includes/icons/alert.svg",
	"./antenna-round.svg": "./docs/_includes/icons/antenna-round.svg",
	"./antenna.svg": "./docs/_includes/icons/antenna.svg",
	"./appendix-round.svg": "./docs/_includes/icons/appendix-round.svg",
	"./appendix.svg": "./docs/_includes/icons/appendix.svg",
	"./approved-round.svg": "./docs/_includes/icons/approved-round.svg",
	"./approved.svg": "./docs/_includes/icons/approved.svg",
	"./arrow-down-round.svg": "./docs/_includes/icons/arrow-down-round.svg",
	"./arrow-down.svg": "./docs/_includes/icons/arrow-down.svg",
	"./arrow-left-round.svg": "./docs/_includes/icons/arrow-left-round.svg",
	"./arrow-left.svg": "./docs/_includes/icons/arrow-left.svg",
	"./arrow-right-round.svg": "./docs/_includes/icons/arrow-right-round.svg",
	"./arrow-right.svg": "./docs/_includes/icons/arrow-right.svg",
	"./arrow-up-round.svg": "./docs/_includes/icons/arrow-up-round.svg",
	"./arrow-up.svg": "./docs/_includes/icons/arrow-up.svg",
	"./attach-round.svg": "./docs/_includes/icons/attach-round.svg",
	"./attach.svg": "./docs/_includes/icons/attach.svg",
	"./attachment-round.svg": "./docs/_includes/icons/attachment-round.svg",
	"./attachment.svg": "./docs/_includes/icons/attachment.svg",
	"./audio-high-round.svg": "./docs/_includes/icons/audio-high-round.svg",
	"./audio-high.svg": "./docs/_includes/icons/audio-high.svg",
	"./audio-low-round.svg": "./docs/_includes/icons/audio-low-round.svg",
	"./audio-low.svg": "./docs/_includes/icons/audio-low.svg",
	"./audio-max-round.svg": "./docs/_includes/icons/audio-max-round.svg",
	"./audio-max.svg": "./docs/_includes/icons/audio-max.svg",
	"./audio-medium-round.svg": "./docs/_includes/icons/audio-medium-round.svg",
	"./audio-medium.svg": "./docs/_includes/icons/audio-medium.svg",
	"./audio-mute-round.svg": "./docs/_includes/icons/audio-mute-round.svg",
	"./audio-mute.svg": "./docs/_includes/icons/audio-mute.svg",
	"./audio-off-round.svg": "./docs/_includes/icons/audio-off-round.svg",
	"./audio-off.svg": "./docs/_includes/icons/audio-off.svg",
	"./auto-loan-round.svg": "./docs/_includes/icons/auto-loan-round.svg",
	"./auto-loan.svg": "./docs/_includes/icons/auto-loan.svg",
	"./auto-round.svg": "./docs/_includes/icons/auto-round.svg",
	"./auto.svg": "./docs/_includes/icons/auto.svg",
	"./bank-account-round.svg": "./docs/_includes/icons/bank-account-round.svg",
	"./bank-account.svg": "./docs/_includes/icons/bank-account.svg",
	"./bank-round.svg": "./docs/_includes/icons/bank-round.svg",
	"./bank.svg": "./docs/_includes/icons/bank.svg",
	"./bookmark-round.svg": "./docs/_includes/icons/bookmark-round.svg",
	"./bookmark.svg": "./docs/_includes/icons/bookmark.svg",
	"./broadcast-round.svg": "./docs/_includes/icons/broadcast-round.svg",
	"./broadcast.svg": "./docs/_includes/icons/broadcast.svg",
	"./building-credit-round.svg": "./docs/_includes/icons/building-credit-round.svg",
	"./building-credit.svg": "./docs/_includes/icons/building-credit.svg",
	"./bullhorn-round.svg": "./docs/_includes/icons/bullhorn-round.svg",
	"./bullhorn.svg": "./docs/_includes/icons/bullhorn.svg",
	"./buying-a-house-round.svg": "./docs/_includes/icons/buying-a-house-round.svg",
	"./buying-a-house.svg": "./docs/_includes/icons/buying-a-house.svg",
	"./buying-car-round.svg": "./docs/_includes/icons/buying-car-round.svg",
	"./buying-car.svg": "./docs/_includes/icons/buying-car.svg",
	"./calendar-round.svg": "./docs/_includes/icons/calendar-round.svg",
	"./calendar.svg": "./docs/_includes/icons/calendar.svg",
	"./car-loan-round.svg": "./docs/_includes/icons/car-loan-round.svg",
	"./car-loan.svg": "./docs/_includes/icons/car-loan.svg",
	"./car-round.svg": "./docs/_includes/icons/car-round.svg",
	"./car.svg": "./docs/_includes/icons/car.svg",
	"./cellphone-round.svg": "./docs/_includes/icons/cellphone-round.svg",
	"./cellphone.svg": "./docs/_includes/icons/cellphone.svg",
	"./chart-round.svg": "./docs/_includes/icons/chart-round.svg",
	"./chart.svg": "./docs/_includes/icons/chart.svg",
	"./check-round.svg": "./docs/_includes/icons/check-round.svg",
	"./check.svg": "./docs/_includes/icons/check.svg",
	"./checkmark-round.svg": "./docs/_includes/icons/checkmark-round.svg",
	"./checkmark.svg": "./docs/_includes/icons/checkmark.svg",
	"./chevron-down-round.svg": "./docs/_includes/icons/chevron-down-round.svg",
	"./chevron-down.svg": "./docs/_includes/icons/chevron-down.svg",
	"./chevron-left-round.svg": "./docs/_includes/icons/chevron-left-round.svg",
	"./chevron-left.svg": "./docs/_includes/icons/chevron-left.svg",
	"./chevron-right-round.svg": "./docs/_includes/icons/chevron-right-round.svg",
	"./chevron-right.svg": "./docs/_includes/icons/chevron-right.svg",
	"./chevron-up-round.svg": "./docs/_includes/icons/chevron-up-round.svg",
	"./chevron-up.svg": "./docs/_includes/icons/chevron-up.svg",
	"./clock-round.svg": "./docs/_includes/icons/clock-round.svg",
	"./clock.svg": "./docs/_includes/icons/clock.svg",
	"./close-quote-round.svg": "./docs/_includes/icons/close-quote-round.svg",
	"./close-quote.svg": "./docs/_includes/icons/close-quote.svg",
	"./close-round.svg": "./docs/_includes/icons/close-round.svg",
	"./close.svg": "./docs/_includes/icons/close.svg",
	"./cog-round.svg": "./docs/_includes/icons/cog-round.svg",
	"./cog.svg": "./docs/_includes/icons/cog.svg",
	"./collapse-round.svg": "./docs/_includes/icons/collapse-round.svg",
	"./collapse.svg": "./docs/_includes/icons/collapse.svg",
	"./college-round.svg": "./docs/_includes/icons/college-round.svg",
	"./college.svg": "./docs/_includes/icons/college.svg",
	"./complaint-round.svg": "./docs/_includes/icons/complaint-round.svg",
	"./complaint.svg": "./docs/_includes/icons/complaint.svg",
	"./contract-round.svg": "./docs/_includes/icons/contract-round.svg",
	"./contract.svg": "./docs/_includes/icons/contract.svg",
	"./copy-round.svg": "./docs/_includes/icons/copy-round.svg",
	"./copy.svg": "./docs/_includes/icons/copy.svg",
	"./credit-card-contract-round.svg": "./docs/_includes/icons/credit-card-contract-round.svg",
	"./credit-card-contract.svg": "./docs/_includes/icons/credit-card-contract.svg",
	"./credit-card-round.svg": "./docs/_includes/icons/credit-card-round.svg",
	"./credit-card.svg": "./docs/_includes/icons/credit-card.svg",
	"./credit-report-round.svg": "./docs/_includes/icons/credit-report-round.svg",
	"./credit-report.svg": "./docs/_includes/icons/credit-report.svg",
	"./date-round.svg": "./docs/_includes/icons/date-round.svg",
	"./date.svg": "./docs/_includes/icons/date.svg",
	"./debt-collection-round.svg": "./docs/_includes/icons/debt-collection-round.svg",
	"./debt-collection.svg": "./docs/_includes/icons/debt-collection.svg",
	"./debt-round.svg": "./docs/_includes/icons/debt-round.svg",
	"./debt.svg": "./docs/_includes/icons/debt.svg",
	"./delete-round.svg": "./docs/_includes/icons/delete-round.svg",
	"./delete.svg": "./docs/_includes/icons/delete.svg",
	"./dialogue-round.svg": "./docs/_includes/icons/dialogue-round.svg",
	"./dialogue.svg": "./docs/_includes/icons/dialogue.svg",
	"./disabled-round.svg": "./docs/_includes/icons/disabled-round.svg",
	"./disabled.svg": "./docs/_includes/icons/disabled.svg",
	"./disallowed-round.svg": "./docs/_includes/icons/disallowed-round.svg",
	"./disallowed.svg": "./docs/_includes/icons/disallowed.svg",
	"./discussion-round.svg": "./docs/_includes/icons/discussion-round.svg",
	"./discussion.svg": "./docs/_includes/icons/discussion.svg",
	"./disk-round.svg": "./docs/_includes/icons/disk-round.svg",
	"./disk.svg": "./docs/_includes/icons/disk.svg",
	"./divide-round.svg": "./docs/_includes/icons/divide-round.svg",
	"./divide.svg": "./docs/_includes/icons/divide.svg",
	"./division-round.svg": "./docs/_includes/icons/division-round.svg",
	"./division.svg": "./docs/_includes/icons/division.svg",
	"./doc-round.svg": "./docs/_includes/icons/doc-round.svg",
	"./doc.svg": "./docs/_includes/icons/doc.svg",
	"./document-round.svg": "./docs/_includes/icons/document-round.svg",
	"./document.svg": "./docs/_includes/icons/document.svg",
	"./dollar-bill-round.svg": "./docs/_includes/icons/dollar-bill-round.svg",
	"./dollar-bill.svg": "./docs/_includes/icons/dollar-bill.svg",
	"./dollar-round.svg": "./docs/_includes/icons/dollar-round.svg",
	"./dollar.svg": "./docs/_includes/icons/dollar.svg",
	"./down-round.svg": "./docs/_includes/icons/down-round.svg",
	"./down.svg": "./docs/_includes/icons/down.svg",
	"./download-round.svg": "./docs/_includes/icons/download-round.svg",
	"./download.svg": "./docs/_includes/icons/download.svg",
	"./duplicate-round.svg": "./docs/_includes/icons/duplicate-round.svg",
	"./duplicate.svg": "./docs/_includes/icons/duplicate.svg",
	"./edit-round.svg": "./docs/_includes/icons/edit-round.svg",
	"./edit.svg": "./docs/_includes/icons/edit.svg",
	"./email-round.svg": "./docs/_includes/icons/email-round.svg",
	"./email-square.svg": "./docs/_includes/icons/email-square.svg",
	"./email.svg": "./docs/_includes/icons/email.svg",
	"./envelope-back-round.svg": "./docs/_includes/icons/envelope-back-round.svg",
	"./envelope-back-square.svg": "./docs/_includes/icons/envelope-back-square.svg",
	"./envelope-back.svg": "./docs/_includes/icons/envelope-back.svg",
	"./envelope-front-round.svg": "./docs/_includes/icons/envelope-front-round.svg",
	"./envelope-front.svg": "./docs/_includes/icons/envelope-front.svg",
	"./envelope-round.svg": "./docs/_includes/icons/envelope-round.svg",
	"./envelope-square.svg": "./docs/_includes/icons/envelope-square.svg",
	"./envelope.svg": "./docs/_includes/icons/envelope.svg",
	"./equal-round.svg": "./docs/_includes/icons/equal-round.svg",
	"./equal.svg": "./docs/_includes/icons/equal.svg",
	"./equals-round.svg": "./docs/_includes/icons/equals-round.svg",
	"./equals.svg": "./docs/_includes/icons/equals.svg",
	"./error-round.svg": "./docs/_includes/icons/error-round.svg",
	"./error.svg": "./docs/_includes/icons/error.svg",
	"./exclamation-mark-round.svg": "./docs/_includes/icons/exclamation-mark-round.svg",
	"./exclamation-mark.svg": "./docs/_includes/icons/exclamation-mark.svg",
	"./expand-round.svg": "./docs/_includes/icons/expand-round.svg",
	"./expand.svg": "./docs/_includes/icons/expand.svg",
	"./external-link-round.svg": "./docs/_includes/icons/external-link-round.svg",
	"./external-link.svg": "./docs/_includes/icons/external-link.svg",
	"./facebook-square.svg": "./docs/_includes/icons/facebook-square.svg",
	"./facebook.svg": "./docs/_includes/icons/facebook.svg",
	"./family-round.svg": "./docs/_includes/icons/family-round.svg",
	"./family.svg": "./docs/_includes/icons/family.svg",
	"./fav-round.svg": "./docs/_includes/icons/fav-round.svg",
	"./fav.svg": "./docs/_includes/icons/fav.svg",
	"./fave-round.svg": "./docs/_includes/icons/fave-round.svg",
	"./fave.svg": "./docs/_includes/icons/fave.svg",
	"./favorite-round.svg": "./docs/_includes/icons/favorite-round.svg",
	"./favorite.svg": "./docs/_includes/icons/favorite.svg",
	"./fax-machine-round.svg": "./docs/_includes/icons/fax-machine-round.svg",
	"./fax-machine.svg": "./docs/_includes/icons/fax-machine.svg",
	"./fax-round.svg": "./docs/_includes/icons/fax-round.svg",
	"./fax.svg": "./docs/_includes/icons/fax.svg",
	"./flickr-square.svg": "./docs/_includes/icons/flickr-square.svg",
	"./flickr.svg": "./docs/_includes/icons/flickr.svg",
	"./fountain-pen-round.svg": "./docs/_includes/icons/fountain-pen-round.svg",
	"./fountain-pen.svg": "./docs/_includes/icons/fountain-pen.svg",
	"./gear-round.svg": "./docs/_includes/icons/gear-round.svg",
	"./gear.svg": "./docs/_includes/icons/gear.svg",
	"./getting-a-credit-card-round.svg": "./docs/_includes/icons/getting-a-credit-card-round.svg",
	"./getting-a-credit-card.svg": "./docs/_includes/icons/getting-a-credit-card.svg",
	"./github-square.svg": "./docs/_includes/icons/github-square.svg",
	"./github.svg": "./docs/_includes/icons/github.svg",
	"./globe-round.svg": "./docs/_includes/icons/globe-round.svg",
	"./globe.svg": "./docs/_includes/icons/globe.svg",
	"./grad-cap-round.svg": "./docs/_includes/icons/grad-cap-round.svg",
	"./grad-cap.svg": "./docs/_includes/icons/grad-cap.svg",
	"./graph-round.svg": "./docs/_includes/icons/graph-round.svg",
	"./graph.svg": "./docs/_includes/icons/graph.svg",
	"./hamburger-round.svg": "./docs/_includes/icons/hamburger-round.svg",
	"./hamburger.svg": "./docs/_includes/icons/hamburger.svg",
	"./handset-round.svg": "./docs/_includes/icons/handset-round.svg",
	"./handset.svg": "./docs/_includes/icons/handset.svg",
	"./help-round.svg": "./docs/_includes/icons/help-round.svg",
	"./help.svg": "./docs/_includes/icons/help.svg",
	"./home-round.svg": "./docs/_includes/icons/home-round.svg",
	"./home.svg": "./docs/_includes/icons/home.svg",
	"./house-round.svg": "./docs/_includes/icons/house-round.svg",
	"./house.svg": "./docs/_includes/icons/house.svg",
	"./i-round.svg": "./docs/_includes/icons/i-round.svg",
	"./i.svg": "./docs/_includes/icons/i.svg",
	"./idea-round.svg": "./docs/_includes/icons/idea-round.svg",
	"./idea.svg": "./docs/_includes/icons/idea.svg",
	"./info-round.svg": "./docs/_includes/icons/info-round.svg",
	"./info.svg": "./docs/_includes/icons/info.svg",
	"./information-round.svg": "./docs/_includes/icons/information-round.svg",
	"./information.svg": "./docs/_includes/icons/information.svg",
	"./left-round.svg": "./docs/_includes/icons/left-round.svg",
	"./left.svg": "./docs/_includes/icons/left.svg",
	"./lightbulb-round.svg": "./docs/_includes/icons/lightbulb-round.svg",
	"./lightbulb.svg": "./docs/_includes/icons/lightbulb.svg",
	"./link-round.svg": "./docs/_includes/icons/link-round.svg",
	"./link.svg": "./docs/_includes/icons/link.svg",
	"./linkedin-square.svg": "./docs/_includes/icons/linkedin-square.svg",
	"./linkedin.svg": "./docs/_includes/icons/linkedin.svg",
	"./list-round.svg": "./docs/_includes/icons/list-round.svg",
	"./list.svg": "./docs/_includes/icons/list.svg",
	"./loan-round.svg": "./docs/_includes/icons/loan-round.svg",
	"./loan.svg": "./docs/_includes/icons/loan.svg",
	"./lock-round.svg": "./docs/_includes/icons/lock-round.svg",
	"./lock.svg": "./docs/_includes/icons/lock.svg",
	"./locked-round.svg": "./docs/_includes/icons/locked-round.svg",
	"./locked.svg": "./docs/_includes/icons/locked.svg",
	"./magnifying-glass-round.svg": "./docs/_includes/icons/magnifying-glass-round.svg",
	"./magnifying-glass.svg": "./docs/_includes/icons/magnifying-glass.svg",
	"./mail-round.svg": "./docs/_includes/icons/mail-round.svg",
	"./mail.svg": "./docs/_includes/icons/mail.svg",
	"./megaphone-round.svg": "./docs/_includes/icons/megaphone-round.svg",
	"./megaphone.svg": "./docs/_includes/icons/megaphone.svg",
	"./menu-round.svg": "./docs/_includes/icons/menu-round.svg",
	"./menu.svg": "./docs/_includes/icons/menu.svg",
	"./mic-round.svg": "./docs/_includes/icons/mic-round.svg",
	"./mic.svg": "./docs/_includes/icons/mic.svg",
	"./microphone-round.svg": "./docs/_includes/icons/microphone-round.svg",
	"./microphone.svg": "./docs/_includes/icons/microphone.svg",
	"./minus-round.svg": "./docs/_includes/icons/minus-round.svg",
	"./minus.svg": "./docs/_includes/icons/minus.svg",
	"./money-round.svg": "./docs/_includes/icons/money-round.svg",
	"./money-transfer-round.svg": "./docs/_includes/icons/money-transfer-round.svg",
	"./money-transfer.svg": "./docs/_includes/icons/money-transfer.svg",
	"./money.svg": "./docs/_includes/icons/money.svg",
	"./mortarboard-round.svg": "./docs/_includes/icons/mortarboard-round.svg",
	"./mortarboard.svg": "./docs/_includes/icons/mortarboard.svg",
	"./mortgage-round.svg": "./docs/_includes/icons/mortgage-round.svg",
	"./mortgage.svg": "./docs/_includes/icons/mortgage.svg",
	"./multiplication-round.svg": "./docs/_includes/icons/multiplication-round.svg",
	"./multiplication.svg": "./docs/_includes/icons/multiplication.svg",
	"./multiply-round.svg": "./docs/_includes/icons/multiply-round.svg",
	"./multiply.svg": "./docs/_includes/icons/multiply.svg",
	"./mute-round.svg": "./docs/_includes/icons/mute-round.svg",
	"./mute.svg": "./docs/_includes/icons/mute.svg",
	"./news-round.svg": "./docs/_includes/icons/news-round.svg",
	"./news.svg": "./docs/_includes/icons/news.svg",
	"./newspaper-round.svg": "./docs/_includes/icons/newspaper-round.svg",
	"./newspaper.svg": "./docs/_includes/icons/newspaper.svg",
	"./no-round.svg": "./docs/_includes/icons/no-round.svg",
	"./no.svg": "./docs/_includes/icons/no.svg",
	"./open-quote-round.svg": "./docs/_includes/icons/open-quote-round.svg",
	"./open-quote.svg": "./docs/_includes/icons/open-quote.svg",
	"./owning-a-home-round.svg": "./docs/_includes/icons/owning-a-home-round.svg",
	"./owning-a-home.svg": "./docs/_includes/icons/owning-a-home.svg",
	"./paper-clip-round.svg": "./docs/_includes/icons/paper-clip-round.svg",
	"./paper-clip.svg": "./docs/_includes/icons/paper-clip.svg",
	"./parent-round.svg": "./docs/_includes/icons/parent-round.svg",
	"./parent.svg": "./docs/_includes/icons/parent.svg",
	"./payday-loan-round.svg": "./docs/_includes/icons/payday-loan-round.svg",
	"./payday-loan.svg": "./docs/_includes/icons/payday-loan.svg",
	"./paying-for-college-round.svg": "./docs/_includes/icons/paying-for-college-round.svg",
	"./paying-for-college.svg": "./docs/_includes/icons/paying-for-college.svg",
	"./pdf-round.svg": "./docs/_includes/icons/pdf-round.svg",
	"./pdf.svg": "./docs/_includes/icons/pdf.svg",
	"./pencil-round.svg": "./docs/_includes/icons/pencil-round.svg",
	"./pencil.svg": "./docs/_includes/icons/pencil.svg",
	"./percent-round.svg": "./docs/_includes/icons/percent-round.svg",
	"./percent.svg": "./docs/_includes/icons/percent.svg",
	"./percentage-round.svg": "./docs/_includes/icons/percentage-round.svg",
	"./percentage.svg": "./docs/_includes/icons/percentage.svg",
	"./person-round.svg": "./docs/_includes/icons/person-round.svg",
	"./person.svg": "./docs/_includes/icons/person.svg",
	"./phone-round.svg": "./docs/_includes/icons/phone-round.svg",
	"./phone.svg": "./docs/_includes/icons/phone.svg",
	"./piggy-bank-check-round.svg": "./docs/_includes/icons/piggy-bank-check-round.svg",
	"./piggy-bank-check.svg": "./docs/_includes/icons/piggy-bank-check.svg",
	"./piggy-bank-round.svg": "./docs/_includes/icons/piggy-bank-round.svg",
	"./piggy-bank.svg": "./docs/_includes/icons/piggy-bank.svg",
	"./play-round.svg": "./docs/_includes/icons/play-round.svg",
	"./play.svg": "./docs/_includes/icons/play.svg",
	"./plus-round.svg": "./docs/_includes/icons/plus-round.svg",
	"./plus.svg": "./docs/_includes/icons/plus.svg",
	"./preferences-round.svg": "./docs/_includes/icons/preferences-round.svg",
	"./preferences.svg": "./docs/_includes/icons/preferences.svg",
	"./prepaid-cards-round.svg": "./docs/_includes/icons/prepaid-cards-round.svg",
	"./prepaid-cards.svg": "./docs/_includes/icons/prepaid-cards.svg",
	"./prepaid-round.svg": "./docs/_includes/icons/prepaid-round.svg",
	"./prepaid.svg": "./docs/_includes/icons/prepaid.svg",
	"./print-round.svg": "./docs/_includes/icons/print-round.svg",
	"./print.svg": "./docs/_includes/icons/print.svg",
	"./printer-round.svg": "./docs/_includes/icons/printer-round.svg",
	"./printer.svg": "./docs/_includes/icons/printer.svg",
	"./question-mark-round.svg": "./docs/_includes/icons/question-mark-round.svg",
	"./question-mark.svg": "./docs/_includes/icons/question-mark.svg",
	"./question-round.svg": "./docs/_includes/icons/question-round.svg",
	"./question.svg": "./docs/_includes/icons/question.svg",
	"./quick-cash-round.svg": "./docs/_includes/icons/quick-cash-round.svg",
	"./quick-cash.svg": "./docs/_includes/icons/quick-cash.svg",
	"./radio-round.svg": "./docs/_includes/icons/radio-round.svg",
	"./radio.svg": "./docs/_includes/icons/radio.svg",
	"./remove-round.svg": "./docs/_includes/icons/remove-round.svg",
	"./remove.svg": "./docs/_includes/icons/remove.svg",
	"./retirement-round.svg": "./docs/_includes/icons/retirement-round.svg",
	"./retirement.svg": "./docs/_includes/icons/retirement.svg",
	"./right-round.svg": "./docs/_includes/icons/right-round.svg",
	"./right.svg": "./docs/_includes/icons/right.svg",
	"./rss-round.svg": "./docs/_includes/icons/rss-round.svg",
	"./rss.svg": "./docs/_includes/icons/rss.svg",
	"./save-round.svg": "./docs/_includes/icons/save-round.svg",
	"./save.svg": "./docs/_includes/icons/save.svg",
	"./search-round.svg": "./docs/_includes/icons/search-round.svg",
	"./search.svg": "./docs/_includes/icons/search.svg",
	"./settings-round.svg": "./docs/_includes/icons/settings-round.svg",
	"./settings.svg": "./docs/_includes/icons/settings.svg",
	"./share-round.svg": "./docs/_includes/icons/share-round.svg",
	"./share.svg": "./docs/_includes/icons/share.svg",
	"./sold-round.svg": "./docs/_includes/icons/sold-round.svg",
	"./sold.svg": "./docs/_includes/icons/sold.svg",
	"./speech-bubble-round.svg": "./docs/_includes/icons/speech-bubble-round.svg",
	"./speech-bubble.svg": "./docs/_includes/icons/speech-bubble.svg",
	"./split-round.svg": "./docs/_includes/icons/split-round.svg",
	"./split.svg": "./docs/_includes/icons/split.svg",
	"./star-round.svg": "./docs/_includes/icons/star-round.svg",
	"./star.svg": "./docs/_includes/icons/star.svg",
	"./starred-round.svg": "./docs/_includes/icons/starred-round.svg",
	"./starred.svg": "./docs/_includes/icons/starred.svg",
	"./subtract-round.svg": "./docs/_includes/icons/subtract-round.svg",
	"./subtract.svg": "./docs/_includes/icons/subtract.svg",
	"./subtraction-round.svg": "./docs/_includes/icons/subtraction-round.svg",
	"./subtraction.svg": "./docs/_includes/icons/subtraction.svg",
	"./success-round.svg": "./docs/_includes/icons/success-round.svg",
	"./success.svg": "./docs/_includes/icons/success.svg",
	"./supplement-round.svg": "./docs/_includes/icons/supplement-round.svg",
	"./supplement.svg": "./docs/_includes/icons/supplement.svg",
	"./tablet-round.svg": "./docs/_includes/icons/tablet-round.svg",
	"./tablet.svg": "./docs/_includes/icons/tablet.svg",
	"./technology-round.svg": "./docs/_includes/icons/technology-round.svg",
	"./technology.svg": "./docs/_includes/icons/technology.svg",
	"./telephone-round.svg": "./docs/_includes/icons/telephone-round.svg",
	"./telephone.svg": "./docs/_includes/icons/telephone.svg",
	"./time-round.svg": "./docs/_includes/icons/time-round.svg",
	"./time.svg": "./docs/_includes/icons/time.svg",
	"./twitter-square.svg": "./docs/_includes/icons/twitter-square.svg",
	"./twitter.svg": "./docs/_includes/icons/twitter.svg",
	"./unbookmark-round.svg": "./docs/_includes/icons/unbookmark-round.svg",
	"./unbookmark.svg": "./docs/_includes/icons/unbookmark.svg",
	"./unfav-round.svg": "./docs/_includes/icons/unfav-round.svg",
	"./unfav.svg": "./docs/_includes/icons/unfav.svg",
	"./unfave-round.svg": "./docs/_includes/icons/unfave-round.svg",
	"./unfave.svg": "./docs/_includes/icons/unfave.svg",
	"./unfavorite-round.svg": "./docs/_includes/icons/unfavorite-round.svg",
	"./unfavorite.svg": "./docs/_includes/icons/unfavorite.svg",
	"./unlock-round.svg": "./docs/_includes/icons/unlock-round.svg",
	"./unlock.svg": "./docs/_includes/icons/unlock.svg",
	"./unlocked-round.svg": "./docs/_includes/icons/unlocked-round.svg",
	"./unlocked.svg": "./docs/_includes/icons/unlocked.svg",
	"./unstar-round.svg": "./docs/_includes/icons/unstar-round.svg",
	"./unstar.svg": "./docs/_includes/icons/unstar.svg",
	"./unstarred-round.svg": "./docs/_includes/icons/unstarred-round.svg",
	"./unstarred.svg": "./docs/_includes/icons/unstarred.svg",
	"./up-round.svg": "./docs/_includes/icons/up-round.svg",
	"./up.svg": "./docs/_includes/icons/up.svg",
	"./update-round.svg": "./docs/_includes/icons/update-round.svg",
	"./update.svg": "./docs/_includes/icons/update.svg",
	"./updating-round.svg": "./docs/_includes/icons/updating-round.svg",
	"./updating.svg": "./docs/_includes/icons/updating.svg",
	"./upload-round.svg": "./docs/_includes/icons/upload-round.svg",
	"./upload.svg": "./docs/_includes/icons/upload.svg",
	"./user-round.svg": "./docs/_includes/icons/user-round.svg",
	"./user.svg": "./docs/_includes/icons/user.svg",
	"./warning-round.svg": "./docs/_includes/icons/warning-round.svg",
	"./warning.svg": "./docs/_includes/icons/warning.svg",
	"./web-round.svg": "./docs/_includes/icons/web-round.svg",
	"./web.svg": "./docs/_includes/icons/web.svg",
	"./wi-fi-round.svg": "./docs/_includes/icons/wi-fi-round.svg",
	"./wi-fi.svg": "./docs/_includes/icons/wi-fi.svg",
	"./wifi-round.svg": "./docs/_includes/icons/wifi-round.svg",
	"./wifi.svg": "./docs/_includes/icons/wifi.svg",
	"./wireless-round.svg": "./docs/_includes/icons/wireless-round.svg",
	"./wireless.svg": "./docs/_includes/icons/wireless.svg",
	"./world-round.svg": "./docs/_includes/icons/world-round.svg",
	"./world.svg": "./docs/_includes/icons/world.svg",
	"./x-round.svg": "./docs/_includes/icons/x-round.svg",
	"./x.svg": "./docs/_includes/icons/x.svg",
	"./youtube-square.svg": "./docs/_includes/icons/youtube-square.svg",
	"./youtube.svg": "./docs/_includes/icons/youtube.svg",
	"./zoom-round.svg": "./docs/_includes/icons/zoom-round.svg",
	"./zoom.svg": "./docs/_includes/icons/zoom.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./docs/_includes/icons sync recursive ^\\.\\/.*\\.svg$";